import React from 'react'
import { Alert, Form } from 'react-bootstrap'

interface BasicAlertProps {
  text: string
  variant: string
  cssClass?: string
}

const BasicAlert: React.FC<BasicAlertProps> = ({ text, variant, cssClass }) => (
  <Form.Group>
    <Alert variant={variant} className={cssClass} transition={false}>
      {text}
    </Alert>
  </Form.Group>
)

export default BasicAlert
